import doris from "../assets/doris.png";
import heroConversation from "../assets/hero-conversation.jpg";

export const dorisPortrait = doris;
export { heroConversation };
